var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SkeletonLoader, getTestId } from '@airtel/air-design-system';
import { ScrollView } from 'react-native';
export var withSkeletonLoading = (Component, options) => {
  var Wrapper = props => {
    var _props$showSkeletonLo = props.showSkeletonLoader,
      showSkeletonLoader = _props$showSkeletonLo === void 0 ? false : _props$showSkeletonLo,
      _props$skeletonLoader = props.skeletonLoaderProps,
      skeletonLoaderProps = _props$skeletonLoader === void 0 ? {} : _props$skeletonLoader,
      restProps = __rest(props, ["showSkeletonLoader", "skeletonLoaderProps"]);
    var spacerHocProps = props.spacerHocProps;
    var _a = Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.skeletonLoaderProps), skeletonLoaderProps),
      _a$numberOfViews = _a.numberOfViews,
      numberOfViews = _a$numberOfViews === void 0 ? 1 : _a$numberOfViews,
      _a$horizontal = _a.horizontal,
      horizontal = _a$horizontal === void 0 ? false : _a$horizontal,
      _a$type = _a.type,
      type = _a$type === void 0 ? 'card-small' : _a$type,
      _a$fullWidth = _a.fullWidth,
      fullWidth = _a$fullWidth === void 0 ? true : _a$fullWidth,
      skeletonLoaderRestProps = __rest(_a, ["numberOfViews", "horizontal", "type", "fullWidth"]);
    var style = {};
    if (!spacerHocProps) {
      style = {
        marginHorizontal: 20,
        marginBottom: 20
      };
    }
    var scrollViewRestProps = Object.assign({}, restProps);
    scrollViewRestProps === null || scrollViewRestProps === void 0 ? true : delete scrollViewRestProps.aspectRatio;
    return _jsx(_Fragment, {
      children: showSkeletonLoader ? _jsx(ScrollView, Object.assign({
        horizontal: horizontal,
        keyboardShouldPersistTaps: "handled",
        scrollEnabled: false
      }, getTestId(props.testID, 'withSkeletonLoading'), scrollViewRestProps, {
        style: style
      }, {
        children: Array(numberOfViews).fill(0).map((_item, index) => _jsx(SkeletonLoader, Object.assign({
          type: type,
          fullWidth: fullWidth
        }, skeletonLoaderRestProps), "skeleton_" + index))
      })) : _jsx(Component, Object.assign({}, restProps))
    });
  };
  return Wrapper;
};